import { useContext } from 'react';
import { RouteCheckContext } from '../providers/RouteCheckProvider';
function useRouteCheck() {
    return useContext(RouteCheckContext);
}
export default useRouteCheck;
